import React from "react";
import { Link } from "react-router-dom";
import "./styles/PolicyPages.css";

const PaymentPolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Payment Policy</h1>
        <p className="policy-updated">Last updated: February 2026</p>

        <section className="policy-section">
          <h2>Payment Processing</h2>
          <p>All payments for VyralNews subscriptions are securely processed through <strong>Stripe</strong>, a PCI-compliant payment processor. VyralNews does not store your credit card or debit card information on our servers. Your payment details are handled entirely by Stripe's secure infrastructure.</p>
        </section>

        <section className="policy-section">
          <h2>Accepted Payment Methods</h2>
          <p>We accept the following payment methods through Stripe:</p>
          <ul>
            <li>Visa</li>
            <li>Mastercard</li>
            <li>American Express</li>
            <li>Discover</li>
            <li>Other major credit and debit cards supported by Stripe</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Subscription Billing</h2>
          <p>When you subscribe to VyralNews, you authorize us to charge your payment method on a recurring basis according to your selected plan:</p>
          <ul>
            <li><strong>Monthly Plan</strong> - Billed once per month</li>
            <li><strong>3-Month Plan</strong> - Billed once every three months</li>
            <li><strong>Yearly Plan</strong> - Billed once per year</li>
          </ul>
          <p>Your subscription will automatically renew at the end of each billing cycle unless you cancel before the renewal date. You can view your next billing date on your <Link to="/user/profile">Profile page</Link>.</p>
        </section>

        <section className="policy-section">
          <h2>Payment Failures</h2>
          <p>If a recurring payment fails (for example, due to an expired card or insufficient funds), Stripe will attempt to process the payment again. If the payment cannot be collected after multiple attempts, your subscription may be suspended or canceled. You will need to update your payment information to restore access.</p>
        </section>

        <section className="policy-section">
          <h2>Cancellation</h2>
          <p>You may cancel your subscription at any time from your <Link to="/user/profile">Profile page</Link>. When you cancel:</p>
          <ul>
            <li>Your access to premium content continues until the end of your current billing period.</li>
            <li>No further charges will be made after the current period ends.</li>
            <li>Your account will revert to a free account with limited access to article content.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Currency</h2>
          <p>All prices are listed and charged in <strong>US Dollars (USD)</strong>. If your payment method is in a different currency, your bank or card issuer may apply a currency conversion fee.</p>
        </section>

        <section className="policy-section">
          <h2>Security</h2>
          <p>We take your payment security seriously. All payment transactions are encrypted and processed through Stripe, which is certified as a PCI Level 1 Service Provider, the most stringent level of certification in the payments industry.</p>
        </section>

        <section className="policy-section">
          <h2>Contact Us</h2>
          <p>If you have questions about payments or billing, please contact us at <a href="mailto:info@vyralmediagroup.com">info@vyralmediagroup.com</a>.</p>
        </section>

        <div className="policy-links">
          <Link to="/pricing">Pricing</Link>
          <Link to="/refund-policy">Refund Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentPolicy;
